import { useState, useCallback } from 'react';
import { t207Api, FT170 } from '../../../services/t207Api';

export function useLookupNames() {
  const [names, setNames] = useState<Record<string, string>>({});

  /** Batch-resolve all lookup names for master */
  const resolveAllNames = useCallback(async (data: Partial<FT170>) => {
    const entries: [string, string, string][] = [
      ['chairman', 'employee', data.ft170_17 || ''],
      ['recorder', 'employee', data.ft170_21 || ''],
    ];
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        t207Api.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  /** Resolve a single lookup name (for onBlur events) */
  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await t207Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  /** Clear all cached names */
  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, setNames, resolveAllNames, resolveSingleName, clearNames };
}
